import { WIDGET_CONTROL_TYPE } from '@examdojo/core/widget';
import type { GeometryPadWidgetConfig } from '../geometrypad.model';

/**
 * Right triangle with button group for trig rules (sin, cos, tan).
 *
 * Each button fires PATCH_DISPLAY to color the sides used in that ratio
 * and grey out the remaining side. Labels show custom names (opp, adj, hyp).
 *
 * Triangle edges (RHS format, right angle at C):
 * - t1.edge.BC = side a = "opp"  (opposite to angle A = θ)
 * - t1.edge.CA = side b = "adj"  (adjacent to angle A = θ)
 * - t1.edge.AB = side c = "hyp"  (hypotenuse)
 */
export const TRIG_BUTTONS_PRESET: GeometryPadWidgetConfig = {
  id: 'trig-buttons',
  type: 'geometrypad',
  params: {
    elements: {
      t1: {
        type: 'Triangle',
        params: { c: 5, a: 3, gamma: 90 },
        names: { a: 'Opposite', b: 'Adjacent', c: 'Hypotenuse', alpha: 'θ' },
      },
    },
  },
  display: {
    geometry: {
      shape: { coloring: true },
      angle: { rightAngleDisplay: 'square', coloring: false },
      label: { names: 'tiered', coloring: true },
    },
  },
  behavior: {
    controls: [
      {
        id: 'btn-sin',
        type: WIDGET_CONTROL_TYPE.Button,
        label: 'sin θ',
        position: 'bottom',
        group: 'trig-rule',
        trigger: {
          action: 'PATCH_DISPLAY',
          payload: {
            't1.edge.BC': { line: { color: 'sky', label: { color: 'sky' } } },
            't1.edge.AB': { line: { color: 'sky', label: { color: 'sky' } } },
            't1.edge.CA': { line: { color: 'neutral', label: { color: 'neutral' } } },
          },
        },
      },
      {
        id: 'btn-cos',
        type: WIDGET_CONTROL_TYPE.Button,
        label: 'cos θ',
        position: 'bottom',
        group: 'trig-rule',
        trigger: {
          action: 'PATCH_DISPLAY',
          payload: {
            't1.edge.CA': { line: { color: 'sky', label: { color: 'sky' } } },
            't1.edge.AB': { line: { color: 'sky', label: { color: 'sky' } } },
            't1.edge.BC': { line: { color: 'neutral', label: { color: 'neutral' } } },
          },
        },
      },
      {
        id: 'btn-tan',
        type: WIDGET_CONTROL_TYPE.Button,
        label: 'tan θ',
        position: 'bottom',
        group: 'trig-rule',
        trigger: {
          action: 'PATCH_DISPLAY',
          payload: {
            't1.edge.BC': { line: { color: 'sky', label: { color: 'sky' } } },
            't1.edge.CA': { line: { color: 'sky', label: { color: 'sky' } } },
            't1.edge.AB': { line: { color: 'neutral', label: { color: 'neutral' } } },
          },
        },
      },
    ],
  },
};
